import { useEffect } from 'react';
import { buildLocalBusinessSchema } from '../utils/localBusinessSchema';

const ATTR = 'data-business-jsonld';

/**
 * Injecte le JSON-LD LocalBusiness dans le <head> de toutes les pages.
 * Le prerender le capture dans le HTML statique ; au chargement, l'ancien script est remplacé
 * pour éviter les doublons.
 */
export const useLocalBusinessJsonLd = () => {
  useEffect(() => {
    document.head.querySelectorAll(`script[${ATTR}]`).forEach((node) => node.remove());
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute(ATTR, '');
    script.textContent = JSON.stringify(buildLocalBusinessSchema());
    document.head.appendChild(script);
  }, []);
};
